export default __webpack_public_path__ + "static/media/project_4.c676baed.png";